import { useEffect, useState } from 'react';

const useModifierKeyPressed = () => {
  const [isPressed, setIsPressed] = useState(false);

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.metaKey) setIsPressed(true);
    };
    const up = () => setIsPressed(false);

    window.addEventListener('keydown', down);
    window.addEventListener('keyup', up);
    window.addEventListener('blur', up);

    return () => {
      window.removeEventListener('keydown', down);
      window.removeEventListener('keyup', up);
      window.removeEventListener('blur', up);
    };
  }, []);

  return isPressed;
};

export default useModifierKeyPressed;
